// icons
import PieChart from '@mui/icons-material/PieChart'
import HomeIcon from '@mui/icons-material/Home'
import ActionsIcon from '@mui/icons-material/VerticalSplitRounded'
import GridOnRounded from '@mui/icons-material/GridOnRounded'
import ViewModuleIcon from '@mui/icons-material/ViewModuleRounded'
import SettingsRounded from '@mui/icons-material/SettingsRounded'
import { MeasuresIcon, ObjectivesIcon } from './views'
// themes
import { colors } from 'themes/index'

export const config = [
  {
    label: 'Home',
    icon: <HomeIcon htmlColor={colors.white100} />,
    path: ['/home'],
    getLink: () => ({ href: '/home' })
  },
  {
    label: 'Forms',
    icon: <GridOnRounded htmlColor={colors.white100} />,
    path: ['/forms'],
    getLink: () => ({ href: '/forms' })
  },
  {
    label: 'Plans',
    icon: <ViewModuleIcon htmlColor={colors.white100} />,
    path: ['/plans'],
    getLink: () => ({ href: '/plans', query: { slug: 'all' } })
  },
  {
    label: 'Indicators',
    icon: <MeasuresIcon />,
    path: ['/kpis'],
    getLink: () => ({ href: '/kpis', query: { slug: 'all' } })
  },
  {
    label: 'Actions',
    icon: <ActionsIcon htmlColor={colors.white100} />,
    path: ['/actions'],
    getLink: () => ({ href: '/actions', query: { slug: 'all' } })
  },
  {
    label: 'Objectives',
    icon: <ObjectivesIcon htmlColor={colors.white100} />,
    path: ['/objectives'],
    getLink: () => ({ href: '/objectives', query: { slug: 'all' } })
  },
  {
    label: 'Reports',
    icon: <PieChart htmlColor={colors.white100} />,
    path: ['/data-hub'],
    getLink: () => ({ href: '/data-hub' })
  },
  {
    label: 'Settings',
    icon: <SettingsRounded htmlColor={colors.white100} />,
    path: ['/account', '/settings'],
    getLink: () => ({ href: '/settings/users' })
  }
]
